/* eslint eqeqeq : 'off' */
import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';

export function SaveMeterDetails(TenantId,data) { 
    return function (dispatch) {
        return APIutil.postData(url.save_Tenant_Meter + TenantId + '/meters',data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200){
                dispatch(GetMeterListforTenant(TenantId));
                dispatch(actionToStoreSuccess(response.data[0].ConsumptionId,types.GET_METERS_DATALOG));
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function UpdateMeterDetails(TenantId, ConsumptionId, data) { 
    return function (dispatch) {
        return APIutil.editDataAPI(url.save_Tenant_Meter + TenantId + '/meters/' + ConsumptionId, data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200){
                dispatch(GetMeterListforTenant(TenantId));
                dispatch(actionToStoreSuccess(response.data,types.GET_METERS_DATALOG));
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function DeleteMeters(TenantId,meters_to_be_deleted) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.save_Tenant_Meter + 0 + '/meters',meters_to_be_deleted).then(response => {
        dispatch(global_error_handling(response));    
        if(response.status == 200)
              dispatch(GetMeterListforTenant(TenantId));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetDatalogValue(objectId, parentobjectId, unit) {
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Datalog_Value + objectId +'/currentvalue/' + parentobjectId + '/' + unit ).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined && response.length > 0)
               dispatch(actionToStoreSuccess(response,types.GET_DATALOG_VALUE_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetDatalogValueForMeterObjects(ObjectId,Unit){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_Tenant_Meters+'datalog/'+ObjectId+'/'+Unit).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response, types.GET_DATALOG_FOR_METERS_OBJECTS));
        }).catch(error => {
            throw error;
        })
    }
}

//get Meters by Tenant ID
export function GetMeterListforTenant(id) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Zone_By_ID+id+"/meters").then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined)
              dispatch(actionToStoreSuccess(response,types.GET_METERS_BY_TENANT_ID));
        }).catch(error => {
            throw error;
        })
    }
}

/* Action to Store method returns the action type with the API response. The response object{type,response}
 will be returned to the Reducer checking it type and updates the state. */

export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}
















